import React from 'react';
import { Text, FontWeights, ITheme, IStyle, getTheme, mergeStyleSets, FontIcon } from '@fluentui/react';
import { GlobalNavButtonIcon } from '@fluentui/react-icons-mdl2';
import { BwjPalette } from '../../app/app-theme';

const boldStyle = { root: { fontWeight: FontWeights.regular } };

const styleFactory = (theme: ITheme) => {
  const topNav: IStyle = {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    backgroundColor: BwjPalette.themePrimaryDark,
    height: 48,
  };
  
  const leftContainer: IStyle = {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    backgroundColor: BwjPalette.themePrimaryDark,
    height: 48,
  };

  const appLabel: IStyle = {
    display: 'flex',
    flexDirection: 'row',
    backgroundColor: theme.palette.themePrimary,
    color: theme.palette.white,
    height: '100%',

    '@media(min-width: 501px)': {
      width: 220,
    },
  };

  const menuButton: IStyle = {
    display: 'none',
    width: 48,
    height: 48,
    backgroundColor: 'inherit',
    border: 'none',
    color: 'inherit',
    padding: 0,
  };

  const desktopMenuButton: IStyle = {
    ...menuButton,

    '@media(min-width: 501px)': {
      display: 'block',
    },
  };

  const mobileMenuButton: IStyle = {
    ...menuButton,

    '@media(max-width: 500px)': {
      display: 'block',
    },
  };

  const menuButtonIcon: IStyle = {
    width: '20px !important',
    height: '20px !important',
    margin: 14,
  
    '& svg': {
      strokeWidth: 20,
      stroke: 'currentColor',
    },
  };

  const logo: IStyle = {
    display: 'block',
    boxSizing: 'border-box',
    height: '100%',
    padding: '10px 12px',
  
    '& i': {
      display: 'block',
      margin: 0,
      padding: 0,
      height: '100%',
    },
  };

  const logoExtension: IStyle = {
    display: 'none',
    width: 100,
    height: '100%',
  };

  const title: IStyle = {
    margin: '0 16px',
    padding: 0,
    color: theme.palette.white,
  };

  const rightContainer: IStyle = {
      display: 'flex',
      flexDirection: 'row',
      height: '100%',
      alignItems: 'center',
      flexGrow: 1,
      justifyContent: 'flex-end',
  };

  return {
    topNav,
    leftContainer,
    appLabel,
    desktopMenuButton,
    mobileMenuButton,
    menuButtonIcon,
    logo,
    logoExtension,
    title,
    rightContainer,
  };
}

export interface IAppHeaderProps {
  title: string;
  showMenuButton: boolean;
  onDesktopMenuButtonClick: () => void;
  onMobileMenuButtonClick: () => void;
}

export const AppHeader: React.FunctionComponent<IAppHeaderProps> = (props) => {
  const theme = getTheme();
  const classNames = mergeStyleSets(styleFactory(theme));

  return (
    <nav className={classNames.topNav}>
      <div className={classNames.leftContainer}>
        <label className={classNames.appLabel}>
          {props.showMenuButton ? 
            <button className={classNames.desktopMenuButton} onClick={props.onDesktopMenuButtonClick}>
              <GlobalNavButtonIcon className={classNames.menuButtonIcon} />
            </button> : null}
          {props.showMenuButton ? 
            <button className={classNames.mobileMenuButton} onClick={props.onMobileMenuButtonClick}>
              <GlobalNavButtonIcon className={classNames.menuButtonIcon} />
            </button> : null}
          <div className={classNames.logo}>
            <FontIcon iconName='IDBadge' />
          </div>
          <div className={classNames.logoExtension}></div>
        </label>
        <h1 className={classNames.title}>
          <Text variant="large" styles={boldStyle}>
            {props.title}
          </Text>
        </h1>
      </div>
      <div className={classNames.rightContainer}>
      </div>
    </nav>
  );
};